'use client';

import React from 'react';
import Image from 'next/image';
import { useRouter, useSearchParams } from 'next/navigation';
import Services from './Services';
import ConsultationBtn from '@/components/resume/resume-marketing/ConsultationBtn';
import ConsultUser from '@/components/resume/resume-marketing/ConsultUser';
import ConsultClassify from '@/components/resume/resume-marketing/ConsultClassify';
import ResumeIntro from '@/components/resume/resume-marketing/ResumeIntro';
import {
  LOGIN_ROUTER_PATH,
  RESUME_CONSULTATION_ORDER_ROUTER_PATH,
} from '@/constants/router-path';
import { QUERY_REDIRECT, QUERY_SCROLL } from '@/constants/auth';
import { BASE_HEADER_HEIGHT } from '@/constants/profile-builder';
import { RESUME_CONSULT_SERVICE_ID } from '@/constants/component-id';
import { useClintMediaQuery } from '@/utils/hooks/useClintMediaQuery';
import { useGsap } from '@/utils/hooks/useGsapScroll';
import BgImage from '@/assets/resume-consult/bg.png';

const ResumeConsult = () => {
  const router = useRouter();
  const searchParam = useSearchParams()?.get(QUERY_SCROLL) || '';

  const isMobile = useClintMediaQuery();

  const handleGoods = (id: string[]) => {
    sessionStorage.setItem(RESUME_CONSULT_SERVICE_ID, JSON.stringify(id));
    router.push(
      `${LOGIN_ROUTER_PATH}?${QUERY_REDIRECT}=${RESUME_CONSULTATION_ORDER_ROUTER_PATH}`,
    );
  };

  useGsap({
    deps: [searchParam],
    condition: searchParam === 'true',
    scrollId: RESUME_CONSULT_SERVICE_ID,
    offsetY: BASE_HEADER_HEIGHT * (isMobile ? 1.1 : 2),
    clearSearchParams: true,
  });

  return (
    <>
      <div
        className="flex justify-center flex-col px-5 py-15 [background:linear-gradient(104.15deg,#f1fff8_3.16%,#b7ebd4_98.14%)] tablet:px-0 tablet:pt-[130px] tablet:pb-[158px] tablet:flex-row"
        data-ele-id="content"
        data-ele-group="landing_量身定制的简历咨询服务"
        data-observer-id="landing_量身定制的简历咨询服务"
      >
        <div className="text-center tablet:mr-[292px] tablet:text-left">
          <p className="text-[2.375rem] mb-5 font-semibold tablet:text-5xl tablet:leading-16 tablet:mb-3">
            量身定制的简历咨询服务
          </p>
          <p className="mb-6 w-full text-lg tablet:w-[346px] tablet:mb-8">
            80%候选人都止步在简历筛选这里，原因是候选人没有呈现出目标岗位所需的核心能力
          </p>
          <ConsultationBtn dataEleGroup="landing_量身定制的简历咨询服务" />
        </div>
        <div className="w-full mt-12 tablet:max-w-[340px] tablet:mt-0">
          <Image
            src={BgImage}
            alt=""
            style={{
              objectFit: 'contain',
            }}
          />
        </div>
      </div>
      <div className="mt-20 px-5 tablet:mt-25 tablet:px-0">
        <Services handleGoods={handleGoods} />
      </div>
      <ConsultClassify />
      <ConsultUser />
      <ResumeIntro />
    </>
  );
};

export default ResumeConsult;
